'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _exchangeToken = require('./exchangeToken');

var _exchangeToken2 = _interopRequireDefault(_exchangeToken);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Token expiration is hardcoded at 10 minutes
// https://docs.microsoft.com/en-us/azure/cognitive-services/Speech/how-to/how-to-authentication?tabs=Powershell#use-an-authorization-token


var TOKEN_EXPIRATION = 600000;
var TOKEN_EARLY_RENEWAL = 60000;

var _class = function () {
  function _class(subscriptionKey) {
    (0, _classCallCheck3.default)(this, _class);
    this.subscriptionKey = subscriptionKey;

    this._renew();
  }

  (0, _createClass3.default)(_class, [{
    key: '_renew',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee() {
        var _this = this;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                clearTimeout(this._renewal);
                this.authorized = (0, _exchangeToken2.default)(this.subscriptionKey);
                _context.next = 4;
                return this.authorized;

              case 4:
                this.value = _context.sent;
                this._renewal = setTimeout(function () {
                  _this._renew();
                }, TOKEN_EXPIRATION - TOKEN_EARLY_RENEWAL);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _renew() {
        return _ref.apply(this, arguments);
      }

      return _renew;
    }()
  }]);
  return _class;
}();

exports.default = _class;